<template>
  <div>
    <span class="text-[#FFD602] font-semibold xl:text-[20px]">Trao thưởng</span>
    <ul class="flex flex-col gap-2 pl-6">
      <li v-for="item of awardList" :key="item.id" class="list-disc">{{ item.content }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AwardComponent',
  data() {
    return {
      awardList: [
        {
          id: 1,
          content: 'Thời gian trao thưởng:  Từ 01/12/2025 - 10/12/2025'
        },
        {
          id: 2,
          content: 'Hình thức trao thưởng: Trung tâm IELTS MENTOR sẽ liên hệ & gửi quà về tận nhà cho khách hàng.'
        },
        {
          id: 3,
          content: 'Trường hợp sau thời gian trao thưởng, khách hàng vẫn chưa nhận được quà vui lòng liên hệ trung tâm qua hotline 19004455 để được hỗ trợ.'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>